import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { User } from "@models/user.model";
import { Organization } from "@models/organization.model";

export const UserActions = createActionGroup({
  source: "User",
  events: {
    "Set Active User": props<{ account: any }>(),
    "Clear Active User": emptyProps(),
    "Logout Button Pressed": emptyProps(),

    "Get User On Login": props<{ email: string }>(),
    "Get User On Login Success": props<{ user: User }>(),
    "Get User On Login Failure": props<{ error: string }>(),

    "Update User LastLogin": props<{ user: User }>(),
    "Update User LastLogin Success": props<{ user: User }>(),
    "Update User LastLogin Failure": props<{ error: string }>(),

    "Get User Organization Ids Success": props<{ ids: number[] }>(),
    "Get User Organization Ids Failure": props<{ error: string }>(),

    "Set User Organization Id": props<{ id: number }>(),

    "All Orgs Disabled Warning": props<{ orgName: string }>(),

    "Org Switched To Enabled": props<{
      oldOrgName: string;
      newOrgName: string;
    }>(),

    "Login Orgs Loaded": props<{ user: User; orgs: Organization[] }>(),
  },
});
